import { render, staticRenderFns } from "./NewsDetail3.vue?vue&type=template&id=0dd4dd3f&scoped=true"
var script = {}
import style0 from "./NewsDetail3.vue?vue&type=style&index=0&id=0dd4dd3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4dd3f",
  null
  
)

export default component.exports